import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, output } from '@angular/core';
import { Subscription } from 'rxjs';

import { Table } from '../../domain/models/table';
import { TableService } from '../../domain/services/table.service';

@Component({
    selector: 'app-title',
    imports: [
      CommonModule,
    ],
    templateUrl: './title.component.html',
    styleUrl: './title.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TitleComponent {
  @Input() enableBackButton: boolean = false;
  @Input() enableCloseButton: boolean = true;
  @Input() title: string = '';
  clickClose = output<boolean>()
  clickBack = output<boolean>()

  tableSubscription: Subscription;

  constructor(
    private tableService: TableService,
  ) {
    if(!this.tableSubscription) {
      this.tableSubscription = this.tableService.$openedTable.subscribe((table: Table | null) => {
        if(table && !this.title) {
          if(table.paymentType == 'TOTAL') {
            this.title = 'Pagar o total da mesa';
          } else if(table.paymentType == 'PARTIAL') {
            this.title = 'Pagar o que consumi';
          } else if(table.paymentType == 'CUSTOM') {
            this.title = 'Pagar valor personalizado';
          }
        }
      })
    }
  }

  handleClose() {
    this.clickClose.emit(true)
  }

  handleBack() {
    this.clickBack.emit(true)
  }
}
